import logger from '@/core/observability/logger';
import type { Product } from '@/productDiscovery/algolia/interfaces/product';
import { SponsoredProductsLocationType } from '@/productDiscovery/SponsoredProducts/interfaces/SponsoredProducts';
import {
  ClickTrackingSpec,
  SPTrackingApi,
} from '@/productDiscovery/SponsoredProducts/services/tracking/api';
import getPageAndPosition from '@/productDiscovery/SponsoredProducts/utils/getPageAndPosition/getPageAndPosition';

export const sendClickTracking = async (
  product: Product,
  location: SponsoredProductsLocationType,
  adTrackingData: string,
  cpc: number,
  position: number,
  page: number,
) => {
  try {
    const { sellerId } = product;
    if (!sellerId) return;
    const event: ClickTrackingSpec = {
      product_id: Number(product.productId),
      location,
      position: getPageAndPosition(page, position, location),
      mabaya_ad_info: adTrackingData,
      cpc,
      seller_id: sellerId,
    };

    await SPTrackingApi.trackClick(event);
  } catch (error) {
    logger.error(
      new Error(
        `Unable to track click with ms.sp-tracking : ${error.stack || error}`,
      ),
    );
  }
};
